var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideocall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "60px",
    viewBox: "0 0 68 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6248793,59.9998569 C51.656104,59.9998569 52.4998748,59.1560861 52.4998748,58.1248614 C52.4998748,57.0936368 51.656104,56.2498659 50.6248793,56.2498659 L42.1873994,56.2498659 L39.3749061,44.9998927 L61.8748525,44.9998927 C64.9803138,44.9998927 67.4998391,42.4803675 67.4998391,39.3749061 L67.4998391,5.62498659 C67.4998391,2.51952524 64.9803138,0 61.8748525,0 L5.62498659,0 C2.51952524,0 0,2.51952524 0,5.62498659 L0,39.3749061 C0,42.4803675 2.51952524,44.9998927 5.62498659,44.9998927 L28.1249329,44.9998927 L25.3124397,56.2498659 L16.8749598,56.2498659 C15.8437351,56.2498659 14.9999642,57.0936368 14.9999642,58.1248614 C14.9999642,59.1560861 15.8437351,59.9998569 16.8749598,59.9998569 L50.6248793,59.9998569 Z M61.8748525,41.2499017 L5.62498659,41.2499017 C4.59376194,41.2499017 3.74999106,40.4061308 3.74999106,39.3749061 L3.74999106,5.62498659 C3.74999106,4.59376194 4.59376194,3.74999106 5.62498659,3.74999106 L61.8748525,3.74999106 C62.9060771,3.74999106 63.749848,4.59376194 63.749848,5.62498659 L63.749848,39.3749061 C63.749848,40.4061308 62.9060771,41.2499017 61.8748525,41.2499017 Z M38.3202211,56.2498659 L29.1796179,56.2498659 L31.0546135,48.7498838 L36.4452256,48.7498838 L38.3202211,56.2498659 Z",
    id: "d",
    fill: "#00BCF5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.91c4717a1307baa6d9c01fd5b850f36f.svg";
export { ForwardRef as ReactComponent };